import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  TextField
} from '@material-ui/core';
import React, { Component } from 'react';
import { apiBatchRequest, downloadReport } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';
import { Switch } from '../common/Switch';
import Reports from './Reports';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import './report.less';
import DateFnsUtils from '@date-io/date-fns';
import { DateFormat } from '../../constants/appConstants';
import moment from 'moment';
import Autocomplete from '@material-ui/lab/Autocomplete';
import _ from 'lodash';
import PageHeader from '../common/PageHeader';
import ReportButtons from './ReportButtons';
import {
  EnhancedTableHead,
  GenerateAbsoluteURL,
  getValidEndDate,
  removeDuplicates,
  orderBy,
  getPreviousPayCycle,
  IsAutoRunPagesEnabled
} from '../../utils/helper';
import AdvancedFilter from './AdvancedFilter';
import { getMultilevelGroupedData } from '../../utils/generic';
import { getFormattedValues, getFormattedValuesForReport } from '../../utils/formatData';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
// import TableWithPaginations from './TableWithPaginations';
import PageLandingMessage from '../common/PageLandingMessage/PageLandingMessage'

const headCells = [
  {
    id: 'reportDescription',
    numeric: false,
    disablePadding: true,
    label: 'Description',
    type: 'Text',
    isSort: false,
    className: 'default-text'
  },
  {
    id: 'amount',
    numeric: true,
    disablePadding: true,
    label: 'Amount',
    type: 'Number',
    format: 'MoneyDecimal',
    isSort: false
  }
];
let temcurrentGroupedRow = [];
export default class SDCInvoiceReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMain: false,
      reportData: [],
      employeeSummary: [],
      startDate: moment().startOf('month').format(DateFormat),
      endDate: getPreviousPayCycle().previousPayCycleEndDate,
      showReport: false,
      // marketMasterData: [],
      propertyMasterData: [],
      // market: [{ marketName: 'All' }],
      property: [{ propertyName: 'All' }],
      openSlidingPanel: false,
      showConstructionReport: false,
      showSummaryRow: true,
      parentPmaTitleId: 0,
      isAutoRunEnabled: IsAutoRunPagesEnabled(),
      isSubmitButtonClicked: false,
      advanceFilterConfig: {
        groupBy: {
          masterData: [
            // {
            //   key: 'Property',
            //   value: 'propertyName',
            //   id: 'propertyName',
            //   ssrsReport: 'Property',
            //   numeric: false,
            //   disablePadding: false,
            //   label: 'Property',
            //   type: 'Text'
            // }
          ],
          selected: [{
            key: 'Property',
            value: 'propertyName',
            id: 'propertyName',
            ssrsReport: 'Property',
            numeric: false,
            disablePadding: false,
            label: 'Property',
            type: 'Text'
          }]
        },
        selectedDate: {},
        suppressGraph: false,
        suppressZero: false,
        summaryRows: false,
        showZeroNGraph: false,
        startDate: moment().startOf('month').format(DateFormat),
        // endDate: getPreviousPayCycle().previousPayCycleEndDate,
        order: 'desc',
        orderBy: 'reportDescription'
      }
    };

    this.baseState = this.state;
  }

  componentDidMount() {
    this.GetMasterData();
  }

  goBack = () => {
    this.setState({
      showMain: true
    });
  };

  handleReportChange = (checked) => {
    let parentPmaTitleId = 0;
    let showConstructionReport = false;
    if (checked === true) {
      parentPmaTitleId = 17; // Construction
      showConstructionReport = true;
    }
    this.setState({ parentPmaTitleId, showConstructionReport });
  };

  handleDateChange = (date, name) => {
    const { advanceFilterConfig } = this.state;
    localStorage.setItem('DateRadioSelect', 'CDR');

    if (name === 'startDate') {
      advanceFilterConfig.startDate = moment(date).format(DateFormat);
      localStorage.setItem('selectedstartDate', moment(date).format(DateFormat));

      this.setState({
        [name]: moment(date).format(DateFormat)
      });
    } else {
      advanceFilterConfig.endDate = moment(date).format(DateFormat);
      localStorage.setItem('selectedendDate', moment(date).format(DateFormat));

      this.setState({
        [name]: moment(date).format(DateFormat)
      });
    }
  };

  GetMasterData = () => {
    const sdcMarketId = 7;
    this._asyncRequest = apiBatchRequest([
      {
        url: `${API_URL.Property.GetPropertyMasterData}?marketid=${sdcMarketId}&getSDCProperties=${true}`,
        key: 'propertyMasterData'
      }
    ])
      .then(
        ({
          propertyMasterData
        }) => {
          this._asyncRequest = null;
          if (propertyMasterData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }
          this.setState({
            propertyMasterData: propertyMasterData.data
          }, () => {
            if(this.state.isAutoRunEnabled || this.state.isSubmitButtonClicked){
              this.handleSubmit();
            }            
          });
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  GetBillingInvoiceSummary = () => {
    const { property, parentPmaTitleId } = this.state;
    const propertyId = _.cloneDeep(property.map((x) => x.propertyId));

    const payPeriodStartDate = this.state.startDate;
    const params = {
      reportDate: moment(payPeriodStartDate).format(DateFormat),
      legalEntityId: null,
      propertyId: propertyId.join('|'),
      parentPmaTitleId: parentPmaTitleId
    };
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Report.GetBillingInvoiceSummary,
        params,
        key: 'reportData'
      }
    ])
      .then(({ reportData }) => {
        this._asyncRequest = null;
        if (reportData.success !== true) {
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
        const obj = headCells.find(x => x.id === 'reportDescription');
        obj.isSort = (!this.state.showConstructionReport);
        obj.className = this.state.showConstructionReport ? 'default-text' : '';
        this.setState({
          reportData: reportData.data,
          // reportSummary: reportData.config,
          showReport: true,
          showSummaryRow: (!this.state.showConstructionReport),
          isSubmitButtonClicked: true
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  handleRequestSort = (event, property) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc';
    this.setState({
      order: isAsc ? 'desc' : 'asc',
      orderBy: property
    });
  };

  renderTable = (reportData) => {
    const groupSequence = this.getColumnSequence();
    return (
      <Table className="reportTable" id="rptTable">
        <EnhancedTableHead
          order={this.state.order}
          orderBy={this.state.orderBy}
          onRequestSort={this.handleRequestSort}
          rowCount={reportData.length}
          columnSequence={groupSequence}
          headCells={headCells}
        />
        <TableBody>{this.renderTableRow(
          orderBy(reportData, this.state.orderBy, this.state.order)
        )}
        </TableBody>
      </Table>
    );
  };

  handleClose = () => {
    this.setState({
      openSlidingPanel: false
    });
  };

  resetPage = () => {
    localStorage.setItem('selectedstartDate', moment().startOf('month').format(DateFormat));
    const { advanceFilterConfig } = this.state;
    // advanceFilterConfig.summaryRows = false;
    // advanceFilterConfig.suppressZero = false;
    advanceFilterConfig.startDate = moment().startOf('month').format(DateFormat);
    advanceFilterConfig.groupBy = {
      masterData: [],
      selected: [{
        key: 'Property',
        value: 'propertyName',
        id: 'propertyName',
        ssrsReport: 'Property',
        numeric: false,
        disablePadding: false,
        label: 'Property',
        type: 'Text'
      }]
    };
    this.setState({
      ...this.baseState,
      showReport: this.state.isAutoRunEnabled ? true : false,
      isSubmitButtonClicked: false,
      advanceFilterConfig
    });
    this.GetMasterData();
  };

  handleSubmit = () => {
    localStorage.setItem('selectedstartDate', this.state.startDate);
    this.GetBillingInvoiceSummary();
  };

  handleClickOpen = () => {
    localStorage.setItem('selectedstartDate', this.state.startDate);
    this.setState({
      openSlidingPanel: true
    });
  };

  handlePrintClick = () => {
    this.setState(
      {
        printPage: true
      },
      window.print()
    );
  };

  handleChange = (_e, value, name, optionLabel) => {
    if ((this.state[name] || []).find(x => x[optionLabel] === 'All') === undefined) {
      if (value && value.length === 0) {
        value = [{ [optionLabel]: 'All' }];
        this.setState({ [name]: value });
      } else if ((value || []).find(x => x[optionLabel] === 'All')) {
        this.setState({ [name]: [{ [optionLabel]: 'All' }] });
      } else {
        this.setState({ [name]: value });
      }
    } else {
      value = (value || []).filter(x => x[optionLabel] !== 'All');
      if (value && value.length === 0) {
        value = [{ [optionLabel]: 'All' }];
      }
      this.setState({ [name]: value });
    }
  };

  onAddvanceFilterChange = (advanceFilterConfig) => {
    // temcurrentGroupedRow = [];
    localStorage.setItem('selectedstartDate', this.state.startDate);
    localStorage.setItem('selectedendDate', this.state.endDate);
    const endDate = getValidEndDate(advanceFilterConfig);
    this.setState({
      advanceFilterConfig: advanceFilterConfig,
      openSlidingPanel: false,
      startDate: (advanceFilterConfig.startDate),
      endDate: endDate
    }, () => { this.GetNewHireEmployee(); });
  };

  getColumnSequence = () => {
    return removeDuplicates(
      [
        ...this.state.advanceFilterConfig.groupBy.selected,
        ...this.state.advanceFilterConfig.groupBy.masterData
      ],
      'key'
    );
  };

  adjustColumnSequence = (currentGroupedRow) => {
    this.state.advanceFilterConfig.groupBy.masterData.forEach((x) => {
      currentGroupedRow.push({ key: x.value });
    });
    return currentGroupedRow;
  };

  renderTableRow = (data, onlydata = false) => {
    temcurrentGroupedRow = [];
    return this.renderTableCell(
      getMultilevelGroupedData(
        data,
        this.state.advanceFilterConfig.groupBy.selected.map((x) => x.value)
      ),
      onlydata,
      []
    );
  };

  renderTableCell = (groupedData, onlydata, currentGroupedRow = [], tableCell = [], rowCount = 0) => {
    const sequence = this.getColumnSequence();
    const showSummaryRow = this.state.showSummaryRow;
    groupedData.forEach((d, i) => {
      let column1 = (temcurrentGroupedRow.find(x => x.key === sequence[0].value) || {})?.value || null;
      let totalAmount = 0;
      if (d.data !== undefined) {
        this.renderTableCell(d.data, onlydata, currentGroupedRow, tableCell, rowCount);
        totalAmount = d.data.reduce((total, obj) => (parseFloat(obj.amount) + parseFloat(total)), 0);
        const skey = d.propertyId + '_' + i;
        const skeyvalue = this.adjustColumnSequence(_.cloneDeep(temcurrentGroupedRow));
        const sevenOddClass =
          tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
        const stopBorderClass =
          column1 !== (skeyvalue.find(x => x.key === sequence[0].value) || {}).value ?? '' ? ' rpt-topBorder ' : ' ';
        if (showSummaryRow) {
          tableCell.push(
            <TableRow key={skey}>
              <TableCell className={sevenOddClass}></TableCell>
              <TableCell className={sevenOddClass + stopBorderClass} ><b>{getFormattedValues(' Grand Total', 'Text')}</b></TableCell>
              <TableCell className={sevenOddClass + stopBorderClass} > <b>{getFormattedValuesForReport(totalAmount, 'MoneyDecimal', '$')}</b></TableCell>
            </TableRow>);
        }
      } else {
        const groupColumns = this.state.advanceFilterConfig.groupBy.selected;

        groupColumns?.forEach(g => {
          temcurrentGroupedRow = temcurrentGroupedRow.filter((x) => x.key !== g.value);

          temcurrentGroupedRow.push({ key: g.value, value: d[g.value] });
        });
      }
      const keyvalue = this.adjustColumnSequence(_.cloneDeep(temcurrentGroupedRow));
      const evenOddClass =
        tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
      const topBorderClass =
        column1 !== (keyvalue.find(x => x.key === sequence[0].value) || {}).value ?? '' ? ' rpt-topBorder ' : ' ';

      const key = d.propertyId + '_' + rowCount + '_' + i;
      if (d.data === undefined) {
        if (onlydata) {
          const rowData = {};
          rowData[sequence[0].value] = getFormattedValues(column1 !== d[sequence[0].value] ? d[sequence[0].value] : '', 'Text', true);
          rowData.pmaTitle = d.pmaTitle;
          rowData.amount = d.amount;
        } else {
          tableCell.push(
            <TableRow key={key} className={(showSummaryRow === false && topBorderClass.indexOf('rpt-topBorder') >= 0) ? topBorderClass + 'parent-row' : topBorderClass}>
              <TableCell className={
                evenOddClass +
                topBorderClass
              }>
                {getFormattedValues(column1 !== d[sequence[0].value] && d[sequence[0].value], 'Text')}{' '}
              </TableCell>
              <TableCell
                className={showSummaryRow === true ? evenOddClass + 'rpt-topBorder' : evenOddClass}
              >
                {d.pmaTitle === null
                  ? '-'
                  : getFormattedValues(d.reportDescription, 'TabText')}
              </TableCell>
              <TableCell
                className={showSummaryRow === true ? evenOddClass + 'rpt-topBorder' : evenOddClass}
              >
                {d.amount === null
                  ? '0'
                  : getFormattedValuesForReport(d.amount, 'MoneyDecimal', '$')}
              </TableCell>
            </TableRow>
          );
        }
      }
      rowCount++;
      column1 =
        (temcurrentGroupedRow.find((x) => x.key === sequence[0].value) || {}).value ?? null;
    });
    return tableCell;
  }

  downloadFile = (fileMimeType, type, isPrint = false) => {
    let { property, startDate, parentPmaTitleId } = this.state;
    property = property.filter(x => x.propertyName !== 'All');
    const propertyId = _.cloneDeep(property.map((x) => x.propertyId));

    const dataValue = [
      { key: 'AsofDate', value: moment(startDate).format(DateFormat) }
    ];
    dataValue.push({ key: 'PropertyId', value: (propertyId.join('|') === undefined || propertyId.join('|') === '') ? '0' : propertyId.join('|') });
    dataValue.push({ key: 'ParentPmaTitleId', value: parentPmaTitleId });
    const url = GenerateAbsoluteURL(dataValue, [], 'SDC%20Invoice', type, false, false);

    downloadReport(
      url,
      'Datacenter Invoice Report',
      fileMimeType,
      type,
      isPrint
    );
  }

  render() {
    const {
      showMain,
      reportData,
      startDate,
      // marketMasterData,
      showReport,
      advanceFilterConfig,
      openSlidingPanel,
      propertyMasterData,
      showConstructionReport
    } = this.state;

    // if (marketMasterData.find(x => x.marketName === 'All') === undefined) {
    //   marketMasterData.unshift({ marketName: 'All' });
    // }   

    if (propertyMasterData.find(x => x.propertyName === 'All') === undefined) {
      propertyMasterData.unshift({ propertyName: 'All' });
    }

    return (
      <div>
        {showMain
          ? (
            <Reports></Reports>
          )
          : (
            <>
              <PageHeader
                key={'Datacenter_Invoice_Report'}
                title={'Datacenter Invoice Report'}
                actionsConfig={[
                  {
                    icon: (
                      <ArrowBackIcon
                        size="small"
                        className="back-button no-print"
                      />
                    ),
                    onClick: this.goBack,
                    title: 'Back to Report'
                  }
                ]}
              >
                Datacenter Invoice Report
            </PageHeader>
              <Grid
                container
                spacing={3}
                className="no-print"
                style={{ marginLeft: '10px' }}
              >
                {/* <Grid item xs={12} lg={2}>
                  <Autocomplete
                    multiple
                    blurOnSelect
                    value={this.state.market}
                    onChange={(e, val) => this.handleChange(e, val, 'market', 'marketName')}
                    id="tags-standard"
                    options={removeDuplicates(marketMasterData, 'marketName')}
                    limitTags={2}
                    getOptionLabel={(option) => option.marketName}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Market"
                      // placeholder="Market"
                      />
                    )}
                  />
                </Grid> */}

                {/* <Grid item xs={12} lg={2} className="MuiFormControl-marginNormal"> */}
                <Grid item xs={12} lg={4}>
                  <Autocomplete
                    multiple
                    blurOnSelect
                    value={this.state.property}
                    onChange={(e, val) => this.handleChange(e, val, 'property', 'propertyName')}
                    id="tags-standard"
                    options={removeDuplicates(propertyMasterData, 'propertyName')}
                    limitTags={2}
                    getOptionLabel={(option) => option.propertyName}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Property"
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} lg={2}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container>
                      <KeyboardDatePicker
                        views={['year', 'month']}
                        margin="normal"
                        id="date-picker-dialog"
                        label="Invoice Month"
                        // format="MM/dd/yyyy"
                        // maxDate={endDate}
                        name="startDate"
                        value={startDate}
                        onChange={(e) => this.handleDateChange(e, 'startDate')}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                        className="w-100"
                        inputProps={{ readOnly: true }}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={12} lg={2}>
                  <Grid container>
                    <Switch
                      isChecked={showConstructionReport}
                      onChangeValues={(checked, key) => {
                        this.handleReportChange(checked);
                      }}
                      id={'switch-invoice-report-type_id'}
                      labelText={'Show Construction Invoice Report'}
                      fullWidth
                    />
                  </Grid>
                </Grid>
                <ReportButtons
                  resetPage={this.resetPage}
                  handleSubmit={this.handleSubmit}
                  handleClickOpen={this.handleClickOpen}
                  handlePrintClick={this.handlePrintClick}
                  downloadFile={this.downloadFile}
                  data={reportData}
                  hideAdvanceLink={true}
                />
              </Grid>
              <div className="col-lg-3 buttons">
                <div className="col-lg-12">
                  <AdvancedFilter
                    filterConfig={advanceFilterConfig}
                    onApplyFilter={this.onAddvanceFilterChange}
                    openSlidingPanel={openSlidingPanel}
                    handleClose={this.handleClose}
                  />
                </div>
              </div>
              {(this.state.isAutoRunEnabled === false && this.state.isSubmitButtonClicked === false) && 
                (reportData === null || reportData.length <= 0) && (
                  <PageLandingMessage/>
                )
              }
              {showReport && (reportData == null || reportData.length === 0) && (
                <Grid container spacing={4}>
                  <Grid
                    container
                    direction="row-reverse"
                    justify="center"
                    alignItems="stretch"
                  >
                    <label className="item-big">No Data Available.</label>
                  </Grid>
                </Grid>
              )}
              {showReport && reportData.length > 0 && (
                <>
                  {reportData !== null && (
                    <div className="container" style={{ marginTop: '1rem' }}>
                      <TableContainer component={Paper}>
                        {this.renderTable(reportData)}
                      </TableContainer>

                      {/* <TableWithPaginations
                        tableData={reportData}
                        renderTable={this.renderTable}
                        order={this.state.order}
                        oBy={this.state.orderBy}
                      /> */}
                    </div>
                  )}
                </>
              )}
            </>
          )
        }
      </div>
    );
  }
}
